/** Mint a 32-char lowercase hex workflow id (Guid "N" format). */
export function newWorkflowId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID().replace(/-/g, '').toLowerCase();
  }
  // ponytail: non-secure fallback for tests only; prefer crypto.randomUUID in browser
  return 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/x/g, () =>
    Math.floor(Math.random() * 16).toString(16),
  );
}
